<div class="close"><img ngSrc="./assets/cross.svg" alt="Close" height="16" width="16"></div>

<div class="dialog-header">
  Information

  <div class="icon">
    <img ngSrc="./assets/info.svg" alt="" height="16" width="16">
  </div>
</div>

<div class="body" i18n="@@info_content">
  Die <span class="trade">DRIVOSOL</span> - Familie bietet hochreine und flexible Druckstufen, die nach Kundenwunsch eingestellt werden können. Bei der Herstellung von <span class="trade">DRIVOSOL</span> wird besonders Wert auf die Entfernung von Begleitstoffen gelegt. <span class="trade">DRIVOSOL</span> weißt daher keinerlei Fremdgerüche auf.
</div>
